import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import NvIcon from 'shared/components/nv-icon';
import { AiRolePlay } from 'redux/schemas/models/ai-role-play';
import { CheckIcon, todoIcon, todoProgress } from './todo-row';
import ProgressIcon from '../progress-icon';
import TodoThumbnail, { TodoThumbnailProps } from './todo-thumbnail';
import ActivityDeadline from './activity-deadline';

type AiRolePlayTodoProps = AiRolePlay & TodoThumbnailProps;

function AiRolePlayTodo({
  type,
  title,
  progress,
  expirationDate,
  thumbnailSrc,
  backgroundColor,
}: AiRolePlayTodoProps) {
  const deadlineMoment = moment(expirationDate);
  const currentMoment = moment();

  const isMissed = progress === todoProgress.MISSED;
  const isComplete = progress === todoProgress.COMPLETED;
  const inProgress = progress === todoProgress.IN_PROGRESS;
  const isNotStarted = progress === todoProgress.NOT_STARTED;

  const showDueSoon = expirationDate
    && !isComplete
    && !isMissed
    && deadlineMoment > currentMoment
    && deadlineMoment < moment().add(7, 'days');

  const todoClassNames = [
    'todo-container',
    isComplete && 'completed',
    inProgress && 'in-progress',
    showDueSoon && 'due-soon',
  ]
    .filter(Boolean)
    .join(' ');

  const icon = <NvIcon icon={todoIcon[type]} size='smallest' />;
  const showTodoIcon = isNotStarted || isMissed;
  const showIconProgress = inProgress;
  const showCheckIcon = isComplete;

  return (
    <div className={todoClassNames}>
      <div className='todo-description'>
        <TodoThumbnail
          thumbnailSrc={thumbnailSrc}
          backgroundColor={backgroundColor}
        />
        <div className='todo-icon'>
          {showTodoIcon && icon}
          {showCheckIcon && <CheckIcon />}
          {showIconProgress && <ProgressIcon>{icon}</ProgressIcon>}
        </div>
        <div className='todo-title'>
          {title}
        </div>
      </div>
      <div className='todo-content'>
        <div className='status'>
          {isComplete && t.TIMELINE.EXERCISE_STATUS.SUBMITTED()}
          {inProgress && t.TIMELINE.EXERCISE_STATUS.IN_PROGRESS()}
          {isMissed && t.TIMELINE.EXERCISE_STATUS.MISSED()}
        </div>
        <ActivityDeadline deadline={expirationDate} />
      </div>
    </div>
  );
}

export default AiRolePlayTodo;
